import { Controller } from "@hotwired/stimulus";
import { getJSON } from "../api.js";

// Baner weryfikacji konta (B-58) — sprawdza /api/acting-org/ i odblokuje baner,
// gdy org ma purchasing_enabled=False. Baner jest domyślnie ukryty (hidden) w szablonie.
//
// Wskazówki dla niezweryfikowanego konta są dołączane jako osobne <span>y (createElement/
// textContent — bez innerHTML) do targets["hints"]:
//   - email_verified=False  → „Potwierdź adres e-mail"
//   - phone_verified=False  → „Zweryfikuj numer telefonu"
//
// Umieszczony na body (data-controller="verification") na stronach: account, my_leads, backorder.
// Katalog używa server-side {% if not purchasing_enabled %} — bez tego kontrolera.
export default class extends Controller {
  static targets = ["banner", "hints"];

  async connect() {
    let data;
    try {
      data = await getJSON("/api/acting-org/");
    } catch {
      // Błąd sieci lub uwierzytelnienia — baner pozostaje ukryty; nav/page nie może się wywalić.
      return;
    }

    if (data?.acting?.purchasing_enabled !== false) return;

    if (this.hasBannerTarget) {
      this.bannerTarget.hidden = false;
    }

    if (this.hasHintsTarget) {
      if (data.email_verified === false) {
        const span = document.createElement("span");
        span.textContent = "Potwierdź adres e-mail";
        this.hintsTarget.append(span);
      }
      if (data.phone_verified === false) {
        const span = document.createElement("span");
        span.textContent = "Zweryfikuj numer telefonu";
        this.hintsTarget.append(span);
      }
    }
  }
}
